/* ============================================================
   The Squishy Box — Mystery Box product page
   Renders custom tier cards + rating + trust line from the inline
   window.SB_PDP data (emitted in theme.liquid), and proxies tier
   clicks to Horizon's NATIVE variant picker / buy buttons so the
   real add-to-cart keeps working. Built in JS so it survives the
   theme editor (which only rewrites JSON templates, not assets).
   ============================================================ */
(function () {
  'use strict';

  /* Editable tier copy (lives here because template settings get
     overwritten by the live theme editor). */
  var TIER_META = [
    { sub: 'try it out', pill: '' },
    { sub: 'best for gifting · free shipping', pill: 'most popular' },
    { sub: 'lowest price per piece 🎁', pill: 'best value + free gift' }
  ];
  var DEFAULT_TIER = 2; // 1-based
  var STOCK_TEXT = 'selling fast — only 41 boxes left at this price';

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function el(html) { var d = document.createElement('div'); d.className = 'sb'; d.innerHTML = html; return d; }
  function pi() { return document.querySelector('.product-information'); }
  function nativeRadio(vid) {
    return document.querySelector('.variant-picker input[type="radio"][data-variant-id="' + vid + '"]');
  }

  /* ---- Build the tier cards from inline variant data --------------- */
  function buildTiers() {
    var data = window.SB_PDP;
    if (!data || !data.variants || !data.variants.length) return;
    if (document.querySelector('[data-sb-tiers]')) return;       // already present
    var root = pi(); if (!root) return;
    var anchor = root.querySelector('.variant-picker') || root.querySelector('.product-form-buttons');
    if (!anchor) return;

    var variants = data.variants.slice(0, 3);
    // Pre-select the preferred tier, or fall back to the first available one
    var di = DEFAULT_TIER - 1;
    if (!variants[di] || !variants[di].available) {
      di = -1;
      for (var n = 0; n < variants.length; n++) { if (variants[n].available) { di = n; break; } }
      if (di < 0) di = 0;
    }
    var cards = '';
    variants.forEach(function (v, i) {
      var meta = TIER_META[i] || {};
      var sel = i === di ? ' sb-sel' : '';
      var unavail = v.available ? '' : ' sb-unavailable';
      var pill = meta.pill ? '<span class="sb-pill ' + (i === 2 ? 'sb-best' : 'sb-pop') + '">' + esc(meta.pill) + '</span>' : '';
      var was = v.compare ? '<span class="sb-was">' + esc(v.compare) + '</span>' : '';
      var sub = meta.sub ? '<span class="sb-bs">' + esc(meta.sub) + '</span>' : '';
      cards += '<div class="sb-bundle' + sel + unavail + '" data-variant-id="' + v.id + '"' +
        (v.available ? '' : ' data-unavailable="true"') + ' role="button" tabindex="0" aria-label="' + esc(v.title) + '">' +
        pill + '<span class="sb-radio"></span>' +
        '<span class="sb-bl"><span class="sb-bt">' + esc(v.title) + '</span>' + sub + '</span>' +
        '<span class="sb-bp"><span class="sb-now">' + esc(v.price) + '</span>' + was + '</span></div>';
    });
    var stock = STOCK_TEXT ? '<div class="sb-stockline">🔥 <span>' + esc(STOCK_TEXT) + '</span></div><div class="sb-stockbar"><i></i></div>' : '';
    var node = el('<div class="sb-bundle-block"><div class="sb-bundles" data-sb-tiers>' + cards + '</div>' + stock + '</div>');
    anchor.parentNode.insertBefore(node, anchor);
    syncSelected();
  }

  /* ---- Rating row + micro-trust line ------------------------------- */
  function buildExtras() {
    var root = pi(); if (!root) return;
    /* An SB hero block owns the rating: if its Rating setting is blank, show none. */
    if (!root.querySelector('.sb-rate-row') && !root.querySelector('.sb-pdp-hero')) {
      var price = root.querySelector('.price');
      if (price) {
        var r = el('<p class="sb-rate-row"><span class="sb-stars">★★★★★</span> 4.8</p>');
        price.parentNode.insertBefore(r, price.nextSibling);
      }
    }
    if (!root.querySelector('.sb-undercta')) {
      var bb = root.querySelector('.product-form-buttons');
      if (bb) {
        var t = el('<p class="sb-undercta" style="display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:6px 18px;width:100%;margin:12px 0 0;text-align:center;"><span>🔒 secure checkout</span><span>🚚 fast shipping</span><span>↩️ 30-day money-back</span></p>');
        bb.parentNode.insertBefore(t, bb.nextSibling);
      }
    }
  }

  function variantById(vid) {
    var list = (window.SB_PDP && window.SB_PDP.variants) || [];
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(vid)) return list[i]; }
    return null;
  }
  function idInputEl() {
    return document.querySelector('product-form-component [name="id"], .product-information form [name="id"]');
  }
  function currentVid() {
    var checked = document.querySelector('.variant-picker input[type="radio"]:checked');
    if (checked && checked.getAttribute('data-variant-id')) return checked.getAttribute('data-variant-id');
    var sel = document.querySelector('.variant-picker select');
    if (sel) { var v = ((window.SB_PDP && window.SB_PDP.variants) || []).filter(function (x) { return x.title === sel.value; })[0]; if (v) return String(v.id); }
    var inp = idInputEl();
    return inp ? inp.value : null;
  }
  /* Select the variant in whatever native control exists AND set the form's
     hidden id directly — so the native Add to cart always submits the chosen
     (available) variant, even if the page's default was a now-sold-out one. */
  function setNativeVariant(vid) {
    var radio = nativeRadio(vid);
    if (radio) { if (!radio.checked) radio.click(); }
    else {
      var v = variantById(vid);
      var sel = document.querySelector('.variant-picker select');
      if (sel && v) { sel.value = v.title; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var inp = idInputEl();
    if (inp) inp.value = vid;
    // Keep ?variant= in sync — Horizon reads it first when resolving the cart variant
    try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); history.replaceState({}, '', u); } catch (e) {}
  }
  function selectedVid() {
    var card = document.querySelector('.sb-bundle.sb-sel[data-variant-id]:not(.sb-unavailable)')
            || document.querySelector('.sb-bundle:not(.sb-unavailable)[data-variant-id]');
    return card ? card.getAttribute('data-variant-id') : null;
  }
  function syncSelected() {
    var vid = currentVid();
    document.querySelectorAll('.sb-bundle[data-variant-id]').forEach(function (c) {
      c.classList.toggle('sb-sel', !!vid && c.getAttribute('data-variant-id') === String(vid));
    });
  }

  /* ---- Quantity-breaks selector (funbox): rich cards from SB_FUNBOX -- */
  function buildQtyBreaks() {
    return; /* SB: "Choose your box" bundle card removed — offer handled by the Launch offer app */
    var FB = window.SB_FUNBOX;
    if (!FB || !FB.variants || !FB.variants.length) return;
    if (document.querySelector('[data-sb-tiers]')) return;      // already built (or mystery tiers present)
    var root = pi(); if (!root) return;
    var anchor = root.querySelector('.variant-picker') || root.querySelector('.product-form-buttons');
    if (!anchor) return;

    var variants = FB.variants.slice(0, 3);
    var defIdx = 1; // middle tier ("most popular") by default
    if (!variants[defIdx] || !variants[defIdx].available) {
      defIdx = -1;
      for (var n = 0; n < variants.length; n++) { if (variants[n].available) { defIdx = n; break; } }
      if (defIdx < 0) defIdx = 0;
    }

    var cards = '';
    variants.forEach(function (v, i) {
      var pieces = v.pieces || parseInt((v.title || '').replace(/[^0-9]/g, ''), 10) || 0;
      var titleTxt = pieces ? (pieces + ' squishies') : (v.title || '');
      var isBest = String(v.id) === String(FB.best);
      var isPop = i === defIdx && !isBest;
      var badge = isBest ? '<span class="sb-pill sb-best">best value</span>'
               : (isPop ? '<span class="sb-pill sb-pop">most popular</span>' : '');
      var sub = v.per_unit ? (v.per_unit + ' / piece') : '';
      var was = v.compare ? '<span class="sb-was">' + esc(v.compare) + '</span>' : '';
      var save = (v.save && v.save_pct) ? '<span class="sb-save">Save ' + esc(v.save) + ' (' + v.save_pct + '%)</span>' : '';
      var sel = i === defIdx ? ' sb-sel' : '';
      var un = v.available ? '' : ' sb-unavailable';
      cards += '<div class="sb-bundle sb-qb' + sel + un + '" data-variant-id="' + v.id + '"' +
        (v.available ? '' : ' data-unavailable="true"') + ' role="button" tabindex="0" aria-label="' + esc(titleTxt) + '">' +
        badge +
        '<span class="sb-radio"></span>' +
        '<span class="sb-bl"><span class="sb-bt">' + esc(titleTxt) + '</span>' + (sub ? '<span class="sb-bs">' + esc(sub) + '</span>' : '') + '</span>' +
        '<span class="sb-bp"><span class="sb-now">' + esc(v.price) + '</span>' + was + save + '</span>' +
        '</div>';
    });
    var node = el('<div class="sb-bundle-block sb-qb-block"><div class="sb-qb-head">Choose your box</div><div class="sb-bundles" data-sb-tiers>' + cards + '</div></div>');
    anchor.parentNode.insertBefore(node, anchor);
    syncSelected();
  }

  function initTiers() {
    // Delegated handlers survive Horizon morphing the section on variant change
    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('.sb-bundle[data-variant-id]') : null;
      if (!card || card.getAttribute('data-unavailable') === 'true') return;
      setNativeVariant(card.getAttribute('data-variant-id'));
      syncSelected();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest ? e.target.closest('.sb-bundle[data-variant-id]') : null;
      if (!card) return;
      e.preventDefault(); card.click();
    });
    // Re-inject + resync if a variant change re-rendered the section
    document.addEventListener('variant:update', function () {
      buildTiers(); buildQtyBreaks(); buildExtras(); syncSelected();
    });

    // Bulletproof: at the moment the native add-to-cart form submits, force the
    // chosen available variant id into the form AND the URL (capture phase runs
    // before Horizon's own submit handler reads them).
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || (form.getAttribute && form.getAttribute('data-type') !== 'add-to-cart-form')) return;
      var vid = selectedVid();
      if (!vid) return;
      var inp = form.querySelector('[name="id"]');
      if (inp) inp.value = vid;
      try { var u = new URL(window.location.href); u.searchParams.set('variant', vid); history.replaceState({}, '', u); } catch (err) {}
    }, true);

    buildTiers();
    buildQtyBreaks();
    buildExtras();
    // Select the pre-selected (available) tier in the native control + form id,
    // overriding any stale/sold-out default the page rendered with.
    var pre = document.querySelector('.sb-bundle.sb-sel[data-variant-id]')
           || document.querySelector('.sb-bundle:not(.sb-unavailable)[data-variant-id]');
    if (pre) setNativeVariant(pre.getAttribute('data-variant-id'));
    syncSelected();
  }

  /* ---- Secondary CTAs (final-CTA section) scroll to the buy box ----- */
  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-sb-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var target = document.querySelector('product-form-component, .product-form-buttons, add-to-cart-component');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---- Countdown ----------------------------------------------------- */
  function initCountdown() {
    var node = document.getElementById('sb-cd');
    if (!node) return;
    var hours = parseFloat(node.getAttribute('data-hours')) || 2;
    var end = Date.now() + hours * 3600 * 1000;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = Math.max(0, end - Date.now());
      node.textContent = pad(Math.floor(d / 3.6e6)) + ':' + pad(Math.floor((d % 3.6e6) / 6e4)) + ':' + pad(Math.floor((d % 6e4) / 1e3));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---- Sticky bar reveal -------------------------------------------- */
  function initSticky() {
    var bar = document.getElementById('sb-stickyBar');
    if (!bar) return;
    window.addEventListener('scroll', function () { bar.classList.toggle('sb-show', window.scrollY > 620); }, { passive: true });
  }

  /* ---- FAQ accordion ------------------------------------------------- */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.sb-q > button') : null;
      if (!btn) return;
      btn.parentElement.classList.toggle('sb-open');
    });
  }

  /* ---- Funbox template: relabel CTA + show per-variant prices ------- */
  function initFunbox() {
    var FB = window.SB_FUNBOX;
    if (!FB || !FB.prices) return;

    function annotate() {
      document.querySelectorAll('.variant-picker .variant-option__button-label').forEach(function (label) {
        if (label.querySelector('.sb-vp')) return;
        var input = label.querySelector('input[type="radio"]');
        var vid = input && input.getAttribute('data-variant-id');
        if (!vid || !FB.prices[vid]) return;
        var txt = label.querySelector('.variant-option__button-label__text') || label;
        var span = document.createElement('span');
        span.className = 'sb-vp';
        span.innerHTML = '— ' + FB.prices[vid] + (String(vid) === String(FB.best) ? ' <span class="sb-vp-best">(best value)</span>' : '');
        txt.appendChild(span);
      });
    }
    function relabelCTA() {
      var checked = document.querySelector('.variant-picker input[type="radio"]:checked');
      var vid = checked && checked.getAttribute('data-variant-id');
      var price = vid && FB.prices[vid];
      var hero = document.querySelector('.sb-pdp-hero[data-sb-cta]');
      var label = (hero && hero.getAttribute('data-sb-cta')) || FB.cta;
      document.querySelectorAll('.product-form-buttons .add-to-cart-button').forEach(function (btn) {
        if (/sold\s*out|unavailable/i.test(btn.textContent || '')) return;
        var node = btn.querySelector('.add-to-cart-text__content span span')
                || btn.querySelector('.add-to-cart-text__content');
        if (node && label) node.textContent = label + (price ? ' — ' + price : '');
      });
    }
    relabelCTA();
    document.addEventListener('variant:update', function () { relabelCTA(); });
  }

  function init() {
    initTiers();
    initFunbox();
    initAddButtons();
    initCountdown();
    initSticky();
    initFaq();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
